import { WNextBase } from '../api/wnext-base';

export type ClovyrAICloudSalesToken = {
  app_slug: string;
  salesperson_code: string;
  sales_tier: string;
};

export class SalesTokenAPI extends WNextBase {
  async getClovyrAICloudSalesToken(token: string): Promise<ClovyrAICloudSalesToken> {
    const res = await this.unwrapRes(this.client.get(`/sales-tokens/${token}`));
    return res.data.salesToken;
  }
}